import {Box, Typography} from '@mui/material';
import {Link} from '@tanstack/react-router';
import {useTranslation} from 'react-i18next';
import useCurrentPractitioner from '@/practitioner/hooks/useCurrentPractitioner';
import {COMPANY_DETAIL} from '@/practitioner/routing/paths';
import generateSupportEmailTo from '@/practitioner/utils/generateSupportEmailTo';
import CompanyLogo from '@/shared/components/layout/LoggedInLayout/Sidebar/CompanyLogo';
import {Menu} from '@/shared/components/layout/LoggedInLayout/Sidebar/Menu';
import {
  ProfileImage,
  SidebarWrapper
} from '@/shared/components/layout/LoggedInLayout/Sidebar/styledComponents';
import EmailHelpButton from '@/shared/components/ui/EmailHelpButton';
import InvestigatorManualButton from '@/shared/components/ui/InvestigatorManualButton';
import TelephoneHelpButton from '@/shared/components/ui/TelephoneHelpButton';
import UserImage from '@/shared/components/ui/UserImage';
import {useCompany} from '@/shared/contexts/UserContext/useUserContext';
import {USER_HOME} from '@/shared/routing/paths';
import practitionerMenuItems from './menu';

function PractitionerSidebar({onCloseSidebar}: {onCloseSidebar?: () => void}) {
  const company = useCompany();
  const currentPractitioner = useCurrentPractitioner();
  const investigatorManualLinkForPractitioner = company.investigatorManualLinkForPractitioner;
  const {t} = useTranslation(['shared/common', 'practitioner/common', 'shared/imageProtocol']);
  const menuItems = practitionerMenuItems({currentPractitioner, company, t});
  return (
    <SidebarWrapper>
      <Box
        sx={{
          position: 'sticky',
          top: 15
        }}
      >
        <Link
          to={
            currentPractitioner.practitionerPermissions.administerCompany
              ? COMPANY_DETAIL
              : USER_HOME
          }
        >
          <CompanyLogo company={company} />
        </Link>

        {!company.isForClinicalTrials && (
          <ProfileImage>
            <UserImage user={currentPractitioner} />
          </ProfileImage>
        )}

        <Menu menuItems={menuItems} onCloseSidebar={onCloseSidebar} t={t} />

        <Box
          sx={{
            mt: 3,
            mb: 2
          }}
        >
          <Typography
            variant="h4"
            color="textSecondary"
            sx={{
              mb: '16px'
            }}
          >
            {t('shared/common:support.label')}
          </Typography>
        </Box>
        {company.isForClinicalTrials && investigatorManualLinkForPractitioner ? (
          <InvestigatorManualButton href={investigatorManualLinkForPractitioner} />
        ) : (
          <Box>
            <EmailHelpButton href={generateSupportEmailTo(currentPractitioner, company, t)} />
            <Box sx={{mt: 1}}>
              <TelephoneHelpButton />
            </Box>
          </Box>
        )}
      </Box>
    </SidebarWrapper>
  );
}

export default PractitionerSidebar;
